import { Zap, RefreshCw, CircleCheck, LineChart, MessageSquareText, Users } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';

const FEATURES = [
  {
    icon: Zap,
    title: 'Instant Deck Generation',
    body: 'Upload any material and your full flashcard deck appears in seconds. Every key term, definition and concept — automatically extracted and formatted.',
  },
  {
    icon: RefreshCw,
    title: 'Spaced Repetition Algorithm',
    body: 'Our SM-2 based algorithm schedules each card at the perfect interval. Cards you struggle with come back sooner; mastered cards appear less and less often.',
  },
  {
    icon: CircleCheck,
    title: 'Mastery Tracking',
    body: 'Watch your deck health in real time. See exactly how many cards are new, learning, or mastered — and which topics still need attention.',
  },
  {
    icon: LineChart,
    title: 'Daily Streak & Reminders',
    body: 'Build a study habit with streak tracking and smart daily notifications. Even 5 minutes a day compounds into full mastery over time.',
  },
  {
    icon: MessageSquareText,
    title: 'Edit & Customise',
    body: 'Add your own cards, edit AI-generated ones, add images or mnemonics. Your deck, your way — the AI gives you a head start, you make it perfect.',
  },
  {
    icon: Users,
    title: 'Share Your Deck',
    body: 'Send a deck to the whole class with one link. Everyone studies from the same material — great for group prep before a shared exam.',
  },
];

const FlashcardsFeatures = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <div className="glow left-1/2 top-0 h-[360px] w-[600px] -translate-x-1/2 bg-accent/8" />
      <Container className="relative">
        <Reveal className="text-center">
          <span className="eyebrow">What You Get</span>
          <h2 className="font-heading mx-auto mt-5 max-w-3xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">Flashcards That Think </span>
            <span className="text-accent-grad">Ahead Of You</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] text-white/55">
            Every deck is a living, adapting study tool — not a static pile of cards.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 90}>
              <div className="glass glass-hover h-full rounded-2xl p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/12 text-accent">
                  <f.icon size={21} />
                </span>
                <h3 className="font-heading mt-5 text-[1.1rem] font-semibold text-white">
                  {f.title}
                </h3>
                <p className="mt-2 text-[0.87rem] leading-relaxed text-white/55">
                  {f.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FlashcardsFeatures;
